import PropTypes from 'prop-types';

import ProductActions from '@/components/product/ProductActions';
import ProductBonus from '@/components/product/ProductBonus';

import styles from './ProductImageAndActions.module.scss';
import React from 'react';

export const ProductImageAndActions = ({
  t,
  items,
  product,
  quantity,
  currentItem,
  setQuantity,
  addToCartRef,
  handleItemChange,
  scrollToAttributes,
  scrollToWineboxPanel,
  wineBoxPromotePosition
}) => (
  <>
    <div className={styles.product}>
      <ProductBonus product={product} currentItem={currentItem} />
    </div>
    <div className={styles.actions} data-rbf="product-action">
      <ProductActions
        items={items}
        product={product}
        quantity={quantity}
        currentItem={currentItem}
        setQuantity={setQuantity}
        addToCartRef={addToCartRef}
        onItemChange={handleItemChange}
        scrollToAttributes={scrollToAttributes}
        scrollToWineboxPanel={scrollToWineboxPanel}
        wineBoxPromotePosition={wineBoxPromotePosition}
        t={t}
      />
    </div>
  </>
);

ProductImageAndActions.propTypes = {
  t: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  product: PropTypes.object.isRequired,
  quantity: PropTypes.number.isRequired,
  setQuantity: PropTypes.func.isRequired,
  addToCartRef: PropTypes.object.isRequired,
  currentItem: PropTypes.object.isRequired,
  scrollToRatings: PropTypes.func,
  handleItemChange: PropTypes.func,
  scrollToAttributes: PropTypes.func,
  scrollToWineboxPanel: PropTypes.func,
  wineBoxPromotePosition: PropTypes.string
};

export default ProductImageAndActions;
